// extracted by mini-css-extract-plugin
export default {"imageWrapper":"UG-z","twoColumnImage":"VG-z"};